import langs from "../constants/langs"
import { loadScript } from "@tencent/midas-util"

export function initMqqJsApi() {
  if (window.mqq) {
    return Promise.resolve(window.mqq)
  } else {
    return new Promise(resolve => {
      loadScript(langs.MQQ_JSAPI_URL, () => {
        resolve(window.mqq)
      })
    })
  }
}

export function initQCJsApi() {
  if (window.qc) {
    return Promise.resolve(window.qc)
  } else {
    return Promise.reject()
    // return new Promise(resolve => {
    //   getScript(langs.QC_JSAPI_URL, "utf-8", { appid: "101502376" }).then(() => {
    //     resolve(window.qc)
    //   })
    // })
  }
}

export function refreshTitle() {
  initMqqJsApi().then(mqq => {
    mqq.ui.refreshTitle()
  })
}

export function isFollowUin() {
  return new Promise((resolve, reject) => {
    initMqqJsApi().then(mqq => {
      mqq.data.isFollowUin({ uin: "3042703080" }, function(result) {
        if (result.ret === 0) {
          resolve(result.response.follow)
        } else {
          reject(result)
        }
      })
    })
  })
}

export function hideTitleRight() {
  initMqqJsApi().then(mqq => {
    // mqq.ui.setActionButton({
    //   hidden: true
    // })
    mqq.ui.setWebViewBehavior({
      actionButton: 0
    })
  })
}
